var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$route.params.categoryName == 'documents')?_c('Documents'):_c('Layout',[_c('UI',{attrs:{"ui":_vm.ui,"setTopbarControls":_vm.setTopbarControls,"topbarControls":_vm.topbarControls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }